import initialErrorState from './initialErrorState';

export default {
    status: {
        loading: false,
        error: initialErrorState,
        isInitialized: false
    }
};
